import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const CaptivatingFact = ({blok}) => {

  return (
    <div {...storyblokEditable(blok)} >
      <div className="font-serif my-2">{blok.factTitle}</div>
      <div className="my-4" dangerouslySetInnerHTML={{__html: renderRichText(blok.factDescription)}}>
      </div>
      { blok.factImage &&
      <img className="w-full h-[215px] object-cover rounded" loading="lazy" src={`${blok.factImage?.filename}/m/640x400`} alt={blok.factImage?.alt} />
      }
    </div>
  )

}

export default CaptivatingFact
